module.exports = __webpack_public_path__ + "static/media/login.b2cd4876.svg";